module.exports = __webpack_public_path__ + "img/healthcare.8bd47fba.png";